import { render, staticRenderFns } from "./Enchallenge.vue?vue&type=template&id=6b52b842&scoped=true&"
import script from "./Enchallenge.vue?vue&type=script&lang=js&"
export * from "./Enchallenge.vue?vue&type=script&lang=js&"
import style0 from "./Enchallenge.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Enchallenge.vue?vue&type=style&index=1&id=6b52b842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52b842",
  null
  
)

export default component.exports